import { RouteFullScreenModal } from "../../../../components/RouteFullScreenModal";
import { Divider } from "../../../../components/Divider";
import { SpinnerBlock } from "../../../common/Spinner";
import { useParams } from "react-router";
import { useSelector } from "react-redux";
import { useGetProductGroup } from "../service/product-groups-api";
import { MutateProductGroupForm } from "../components";
import * as authSelectors from "../../../auth/authSelectors";

export const EditProductGroupsPage = () => {
  const { id } = useParams();
  const organizationKeyName = useSelector(
    authSelectors.selectedOrganizationKeyName
  );
  const { data: productGroup, isLoading } = useGetProductGroup(
    organizationKeyName,
    id
  );

  return (
    <RouteFullScreenModal title="Edit product group">
      <Divider />
      {isLoading ? (
        <SpinnerBlock />
      ) : (
        <MutateProductGroupForm productGroup={productGroup} />
      )}
    </RouteFullScreenModal>
  );
};
